import { IAppToolConfig } from '../types/appTools';
import { AppToolbarIconConfig } from '../config/AppToolbarIconConfig';
import { AppToolbarIdConfig } from '../config/AppToolbarIdConfig';
import { AppToolbarNotificationHookConfig } from '../config/AppToolbarNotificationHookConfig';
import { AppToolbarAnimatedIconConfig } from '../config/AppToolbarAnimatedIconConfig';
import { getItemEnabled } from '../config/AppToolbarItemEnabled';
import { AppToolbarAwarenessTooltipConfig } from '../config/AppToolbarAwarenessTooltipConfig';
import { AppToolbarAwarenessDotConfig } from '../config/AppToolbarAwarenessDotConfig';

export const createAppToolbarItems = (appToolsConfig: IAppToolConfig[]) => {
    return appToolsConfig.map(config => {
        return {
            id: AppToolbarIdConfig[config.id] ?? config.id,
            extensionId: config.extensionId,
            title: config.title,
            icon: AppToolbarIconConfig[config.id],
            animatedIcon: AppToolbarAnimatedIconConfig[config.id],
            iconUrl: config.iconUrl,
            useNotification: AppToolbarNotificationHookConfig[config.id],
            awareness: {
                tooltip: AppToolbarAwarenessTooltipConfig[config.id],
                dot: AppToolbarAwarenessDotConfig[config.id],
            },
            isEnabled: getItemEnabled(config.type),
            ...(config.category && { category: config.category }),
            ...(config.name && { name: config.name }),
        };
    });
};
